import { Capacitor, registerPlugin } from "@capacitor/core";

/**
 * JS side of the app-local `AppOpenAd` Capacitor plugin
 * (apps/mobile-{cr,cn}/android/app/src/main/java/.../AppOpenAdPlugin.java).
 * Android only — iOS has no native side yet.
 */
export interface AppOpenAdPlugin {
  /** Resolves once an ad is cached (immediately if a fresh one already is). */
  load(options: { adId: string }): Promise<void>;
  /** Resolves when the ad is dismissed; rejects (code NOT_READY) if none is cached. */
  show(): Promise<void>;
}

export const AppOpenAd = registerPlugin<AppOpenAdPlugin>("AppOpenAd");

export function appOpenAdAvailable(): boolean {
  return Capacitor.isPluginAvailable("AppOpenAd");
}
